import { render, staticRenderFns } from "./purview.vue?vue&type=template&id=1a7bfa76&scoped=true&"
import script from "./purview.vue?vue&type=script&lang=js&"
export * from "./purview.vue?vue&type=script&lang=js&"
import style0 from "./purview.vue?vue&type=style&index=0&id=1a7bfa76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bfa76",
  null
  
)

export default component.exports